import { INTERACTION_TYPES, send } from './apopheniaLogger';

const getData = (element) => {
  try {
    return JSON.parse(element.dataset.apopheniaTargetData);
  } catch (_e) {
    return {};
  }
};

/**
 * This logger will query the DOM for any elements that have an `data-apophenia-target`
 * attribute set. When the elements are clicked, an event is synchronously fired to the
 * Apophenia Log Service, and then the default action is permitted to execute.
 *
 * To send custom data along with the event, set a `data-apophenia-target-data` attribute
 * with a JSON string as as the value. Ex:
 *
 * <button
 *  data-apophenia-target="some_button"
 *  data-apophenia-target-data='{"some_key": "some_value"}'
 * >A Button</a>
 *
 * @returns { function } click event handler function
 */
const ApopheniaDeclarativeLogger = ({
  sendLog = send,
  callback = () => {}
} = {}) => {
  const handler = async (e) => {
    const target = e.target.closest('[data-apophenia-target]');

    if (!target) {
      return callback();
    }

    if (target.dataset.apopheniaTargetSent) {
      delete target.dataset.apopheniaTargetSent;
      return callback();
    }

    if (target.dataset.apopheniaTarget) {
      e.preventDefault();
      e.stopImmediatePropagation();

      await new Promise((resolve) => {
        sendLog(
          {
            screen_id: window.location.href,
            element_id: target.id,
            target_name: target.dataset.apopheniaTarget,
            interaction_type: INTERACTION_TYPES.CLICKED,
            ...getData(target)
          },
          resolve
        );
      });

      target.dataset.apopheniaTargetSent = true;

      // Re-click to execute original action.
      target.click();
    }
  };

  document.body.addEventListener('click', handler);

  return handler;
};

export default ApopheniaDeclarativeLogger;
